export const VIEWPORT_SIZE = 1000